import React from 'react';
import { Grid, Message } from 'semantic-ui-react';

/**
 * Placeholder for the Variation Form Panel component
 * This will be replaced with the new variationWorksheet implementation
 * 
 * @returns {JSX.Element} VariationFormPanel component
 */
const VariationFormPanel = () => {
  return (
    <Grid.Column width={10}>
      <Message info>
        <Message.Header>Coming Soon</Message.Header>
        <p>
          The Variation Form Panel feature is currently being reimplemented with an improved architecture.
          This feature will be available in a future update.
        </p>
      </Message>
    </Grid.Column>
  );
};

export default VariationFormPanel;
